import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabComponent } from './tab.component';
import {DxScrollViewModule} from 'devextreme-angular';



@NgModule({
  declarations: [TabComponent],
    imports: [
        CommonModule,
        DxScrollViewModule
    ],
  exports: [TabComponent]
})
export class TabModule { }
